<template>
  <div class="category">
    <a-modal
      v-model:visible="visible"
      :zIndex="10090"
      :title="`${mode == 'add' ? '新增' : '修改'}页面`"
      @ok="handleOk"
      @cancel="cancel"
    >
      <a-form
        :rules="rules"
        layout="vertical"
        class="small"
        ref="blockForm"
        :model="formState"
      >
        <a-form-item label="页面名称：" name="name">
          <a-input v-model:value="formState.name" placeholder="请输入" />
        </a-form-item>
        <a-form-item label="页面地址：" name="url">
          <a-input v-model:value="formState.url" placeholder="请输入" />
        </a-form-item>
      </a-form>
    </a-modal>
  </div>
</template>
<script setup>
import { defineExpose, defineProps, ref, reactive } from 'vue'
import useAPI from 'UseApi'
const {
  category_addOrUpdate_post_,
  category_delete_post_,
  category_list_post_
} = useAPI(null, [8992])
import { Form } from 'ant-design-vue'
const useForm = Form.useForm

const props = defineProps({
  mode: {
    type: String,
    default: 'add'
  },
  categoryId: {
    type: String,
    default: ''
  }
})

const rules = reactive({
  name: [{ required: true, message: 'Please input your username!' }],
  url: [{ required: true, message: 'Please input your username!' }]
})
let initFormState = {
  name: '',
  url: ''
}
let formState = reactive(initFormState)

const blockForm = ref(null)
const visible = ref(false)

const { resetFields, validate } = useForm(formState, rules, {})

const open = item => {
  Object.assign(formState, item)
  switch (item.opera) {
    case 'del':
      console.log(7788)
      break
    default:
      visible.value = !visible.value
      break
  }
  console.log(formState)
}

const handleOk = async () => {
  await validate()
  switch (formState.opera) {
    case 'add':
      await addOrUpdateCategory()
      break
    case 'update':
      await addOrUpdateCategory()
      break
    case 'del':
      await addOrUpdateCategory()
      break
  }
  if (props.mode !== 'add') formState.categoryId === props.categoryId
  visible.value = false
  cancel()
}
const addOrUpdateCategory = async () => {
  await category_addOrUpdate_post_(formState)
}

const getCategory = async () => {
  await category_list_post_(formState)
}

const deleteCategory = async () => {
  await category_delete_post_(formState)
}

console.log(deleteCategory, getCategory)

const cancel = () => {
  resetFields()
}

defineExpose({ open })
</script>
